// Link: https://en.wikipedia.org/wiki/List_of_HTTP_status_codes
export enum EConnectionStatus {
    // 1xx - Informational responses
    STATUS_100 = 100, // Continue
    STATUS_101 = 101, // Switching Protocols
    STATUS_102 = 102, // Processing (WebDAV; RFC 2518)

    // 2xx - Success
    STATUS_200 = 200, // OK
    STATUS_201 = 201, // Created
    STATUS_202 = 202, // Accepted
    STATUS_203 = 203, // Non-Authoritative Information (since HTTP/1.1)
    STATUS_204 = 204, // No Content
    STATUS_205 = 205, // Reset Content
    STATUS_206 = 206, // Partial Content (RFC 7233)
    STATUS_207 = 207, // Multi-Status (WebDAV; RFC 4918)
    STATUS_208 = 208, // Already Reported (WebDAV; RFC 5842)
    STATUS_226 = 226, // IM Used (RFC 3229)

    // 3xx - Redirection
    STATUS_300 = 300, // Multiple Choices
    STATUS_301 = 301, // Moved Permanently
    STATUS_302 = 302, // Found
    STATUS_303 = 303, // See Other (since HTTP/1.1)
    STATUS_304 = 304, // Not Modified (RFC 7232)
    STATUS_305 = 305, // Use Proxy (since HTTP/1.1)
    STATUS_306 = 306, // Switch Proxy
    STATUS_307 = 307, // Temporary Redirect (since HTTP/1.1)
    STATUS_308 = 308, // Permanent Redirect (RFC 7538)

    // 4xx - Client errors
    STATUS_400 = 400, // Bad Request
    STATUS_401 = 401, // Unauthorized (RFC 7235)
    STATUS_402 = 402, // Payment Required
    STATUS_403 = 403, // Forbidden
    STATUS_404 = 404, // Not Found
    STATUS_405 = 405, // Method Not Allowed
    STATUS_406 = 406, // Not Acceptable
    STATUS_407 = 407, // Proxy Authentication Required (RFC 7235)
    STATUS_408 = 408, // Request Time-out
    STATUS_409 = 409, // Conflict
    STATUS_410 = 410, // Gone
    STATUS_411 = 411, // Length Required
    STATUS_412 = 412, // Precondition Failed (RFC 7232)
    STATUS_413 = 413, // Payload Too Large (RFC 7231)
    STATUS_414 = 414, // URI Too Long (RFC 7231)
    STATUS_415 = 415, // Unsupported Media Type
    STATUS_416 = 416, // Range Not Satisfiable (RFC 7233)
    STATUS_417 = 417, // Expectation Failed
    STATUS_418 = 418, // I'm a teapot (RFC 2324) [Easter egg]
    STATUS_421 = 421, // Misdirected Request (RFC 7540)
    STATUS_422 = 422, // Unprocessable Entity (WebDAV; RFC 4918)
    STATUS_423 = 423, // Locked (WebDAV; RFC 4918)
    STATUS_424 = 424, // Failed Dependency (WebDAV; RFC 4918)
    STATUS_426 = 426, // Upgrade Required
    STATUS_428 = 428, // Precondition Required (RFC 6585)
    STATUS_429 = 429, // Too Many Requests (RFC 6585)
    STATUS_431 = 431, // Request Header Fields Too Large (RFC 6585)
    STATUS_451 = 451, // Unavailable For Legal Reasons (RFC 7725)

    // 5xx - Server error
    STATUS_500 = 500, // Internal Server Error
    STATUS_501 = 501, // Not Implemented
    STATUS_502 = 502, // Bad Gateway
    STATUS_503 = 503, // Service Unavailable
    STATUS_504 = 504, // Gateway Time-out
    STATUS_505 = 505, // HTTP Version Not Supported
    STATUS_506 = 506, // Variant Also Negotiates (RFC 2295)
    STATUS_507 = 507, // Insufficient Storage (WebDAV; RFC 4918)
    STATUS_508 = 508, // Loop Detected (WebDAV; RFC 5842)
    STATUS_510 = 510, // Not Extended (RFC 2774)
    STATUS_511 = 511, // Network Authentication Required (RFC 6585)

    // Unofficial codes used for portal-configuration-systems
    STATUS_299 = 299, // Ping OK
    STATUS_440 = 440, // Login Time-out
    STATUS_498 = 498, // Invalid Token
    STATUS_499 = 499, // Token Required

    STATUS_999 = 999 // STATUS not found
}
